<template>
  <Modal>
    <Modal.Title>Leave report creation?</Modal.Title>
    <Modal.Body>
      <p class="text-[14px] leading-[22px] text-gray-800">
        Are you sure you want to close this window and cancel the report? Any
        file you uploaded will be lost.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button
        variant="stroke"
        :size="isMobile ? 'lg' : 'md'"
        @click="closeModal()"
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        @click="handleLeave"
      >
        Leave
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button } from '@dacr/library'
import { useDevice } from '@/shared/composables/useDevice'
import { closeModal, closeAllModals } from '@/shared/dialogs/modals'
import { closeAllSheets } from '@/shared/dialogs/sheets'

const { isMobile } = useDevice()

const handleLeave = () => {
  closeAllModals()
  closeAllSheets()
}
</script>
